import moment from "moment";

export const ORDER_VIEW_COLUMNS = [
  {
    Header: "INVC #",
    accessor: "InvoiceNumber",
    id: "InvoiceNumber",
    Cell: ({ cell }) => (cell.value ? cell.value : "")
  },
  {
    Header: "INVC DATE",
    accessor: "InvoiceDate",
    id: "InvoiceDate",
    Cell: ({ cell }) =>
      cell.value ? moment(cell.value).format("MM/DD/YYYY") : ""
  },
  {
    Header: "Bill To #",
    accessor: "BillToNumber",
    id: "BillToNumber",
    Cell: ({ cell }) => (cell.value ? cell.value : "")
  },
  {
    Header: "Bill To Name",
    accessor: "BillToName",
    id: "BillToName",
    Cell: ({ cell }) => (cell.value ? cell.value : "")
  },
  {
    Header: "Customer #",
    accessor: "CustomerNo",
    id: "CustomerNo",
    Cell: ({ cell }) => (cell.value ? cell.value : "")
  },
  {
    Header: "Customer Name",
    accessor: "CustomerName",
    id: "CustomerName",
    Cell: ({ cell }) => (cell.value ? cell.value : "")
  },
  {
    Header: "Order #",
    accessor: "OrderNumber",
    id: "OrderNumber",
    Cell: ({ cell }) => (cell.value ? cell.value : "")
  },

  {
    Header: "Pickup Date",
    accessor: "PickupDate",
    id: "PickupDate",
    Cell: ({ cell }) =>
      cell.value ? moment(cell.value).format("MM/DD/YYYY") : null
  },
  {
    Header: "Status",
    accessor: "StatusIdDescription",
    id: "StatusIdDescription",
    Cell: ({ cell }) => (cell.value ? cell.value : "")
  },
  {
    Header: "Pickup ID",
    accessor: "Pickup_LocationId",
    id: "PickupLocationID",
    Cell: ({ cell }) => (cell.value ? cell.value : "")
  },
  {
    Header: "Pickup Location",
    accessor: "PickUp_LocationName",
    id: "Pickup_LocationId",
    Cell: ({ cell }) => (cell.value ? cell.value : "")
  },
  {
    Header: "City",
    accessor: "PickUp_City",
    id: "PickUp_City",
    Cell: ({ cell }) => (cell.value ? cell.value : "")
  },
  {
    Header: "State",
    accessor: "PickUp_State",
    id: "PickUp_State",
    Cell: ({ cell }) => (cell.value ? cell.value : "")
  },
  {
    Header: "Delivery ID",
    accessor: "Del_LocationId",
    id: "DeliveryLocationID",
    Cell: ({ cell }) => (cell.value ? cell.value : "")
  },
  {
    Header: "Delivery Location",
    accessor: "Del_LocationName",
    id: "Del_LocationName",
    Cell: ({ cell }) => (cell.value ? cell.value : "")
  },
  {
    Header: "City",
    accessor: "Del_City",
    id: "Del_City",
    Cell: ({ cell }) => (cell.value ? cell.value : "")
  },
  {
    Header: "State",
    accessor: "Del_State",
    id: "Del_State",
    Cell: ({ cell }) => (cell.value ? cell.value : "")
  },
  {
    Header: "Driver Id",
    accessor: "PickupDriver",
    id: "PickupDriver",
    Cell: ({ cell }) => (cell.value ? cell.value : "")
  },
  {
    Header: "Driver Name",
    accessor: "PickupDriverLastName",
    id: "PickupDriverLastName",
    Cell: ({ cell }) => (cell.value ? cell.value : "")
  },
  {
    Header: "Tractor",
    accessor: "PickupTractor",
    id: "PickupTractor",
    Cell: ({ cell }) => (cell.value ? cell.value : "")
  },
  {
    Header: "Trailer",
    accessor: "PickupTrailer",
    id: "PickupTrailer",
    Cell: ({ cell }) => (cell.value ? cell.value : "")
  },
  {
    Header: "Order Date",
    accessor: "OrderDate",
    id: "OrderDate",
    Cell: ({ cell }) =>
      cell.value ? moment(cell.value).format("MM/DD/YYYY") : null
  },
  {
    Header: "INVC BATCH #",
    accessor: "InvoiceBatchNumber",
    id: "InvoiceBatchNumber",
    Cell: ({ cell }) => (cell.value ? cell.value : "")
  },
  {
    Header: "Verified By",
    accessor: "VerifiedByUserId",
    id: "VerifiedByUserId",
    Cell: ({ cell }) => (cell.value ? cell.value : "")
  },
  {
    Header: "Created Date",
    accessor: "CreatedDateTime",
    id: "CreatedDateTime",
    Cell: ({ cell }) =>
      cell.value ? moment(cell.value).format("MM/DD/YYYY HH:mm") : null
  },
  {
    Header: "Created By",
    accessor: "CreatedBy",
    id: "CreatedBy",
    Cell: ({ cell }) => (cell.value ? cell.value : "")
  },
  {
    Header: "Modified Date",
    accessor: "ModifiedDateTime",
    id: "ModifiedDateTime",
    Cell: ({ cell }) =>
      cell.value ? moment(cell.value).format("MM/DD/YYYY") : null
  },
  {
    Header: "Modified By",
    accessor: "ModifiedBy",
    id: "ModifiedBy",
    Cell: ({ cell }) => (cell.value ? cell.value : "")
  }
];
